import React from 'react'
import BaseBtn from './BaseBtn'

const ViewBtn = ({onApply,id }) => {
  return (
    <BaseBtn icon={"mdi:eye"} className='view' reqAction="canGet" onApply={() => onApply(id)} />
  )
}

export default ViewBtn